//
//   Copyright (c) 2020-2024, ResMed Inc. All rights reserved.
//

import React from "react";
import { Typography, Box } from "@mui/material";
import PropTypes from 'prop-types';

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";

const ErrorPageContent = ({ message }) => {
    const { t } = useTranslation("pages.MaskSelectorTool.MaskSelectorTool");
    const helpSuggestion = t("helpSuggestion");

    const {classes} = MaskSelectorToolStyles();

    return (
        <Box className={classes.blue_gradient_box}
             color="primary.contrastText"
             p={2}
             pt={5}
        >
            <Box mb={2}>
                <Typography variant="h6">{message}</Typography>
            </Box>
            <Typography variant="h6">
                { helpSuggestion }
            </Typography>
        </Box>
    );
};
ErrorPageContent.propTypes = {
    message: PropTypes.string.isRequired
}

export default ErrorPageContent;